import { ActionTree } from 'vuex'
import { State } from './interfaces'

export default {

} as ActionTree<State, any>
